/**
 * init
 */
var rv = 1000,
	_touch = false,
	_tablet = false;

css_browser_selector(navigator.userAgent);

var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})"); if(re.exec(navigator.userAgent) !== null) rv = parseFloat(RegExp.$1);

$(function()
{
	setup_forms();

	$('input, textarea').placeholder();

	if(window.location.hash != '') {
		window.scrollTo(0, 0);

		$('html,body').delay(200).animate({scrollTop:$(window.location.hash).offset().top}, 1250, 'easeInOutExpo');
	}

	$('.navbar-toggle').on('click', function() {
		$('nav[role="navigation"]').slideToggle('fast');
	});


	$('#questions').on('click', 'h3', function() {
		var item = $(this);
		var content = item.closest('.faq-item');

		content.find('.faq-item-content').slideToggle('fast');

		setTimeout(function () {
			if (content.find('.faq-item-content').is(":visible")) {
				item.find('i').text('-');
			} else {
				item.find('i').text('+');
			}
		}, 210);
	});



	if($(".owl-carousel").length) {
		$(".owl-carousel").owlCarousel({
			loop		: true,
			margin		: 0,
//			lazyLoad	: true,
			responsive	: {
				0: {
					items	: 1,
//					nav		: true,
					loop	: true
				}
			},
			autoplay			: true,
			autoplaySpeed		: 1000,
			autoplayTimeout		: 5000,
			autoplayHoverPause	: true
		});
	}

	if($('#forgot-password').length) {
		$('#forgot-password').on('click', function() {
			$('#login-form').slideToggle(300);
			$('#password-form').delay(150).slideToggle(300);
		});
		$('#do-login').on('click', function() {
			$('#password-form').slideToggle(300);
			$('#login-form').delay(150).slideToggle(300);
		});
	}

	if($('#show-register').length) {
		$('#show-register').on('click', function() {
			$('#register-form').slideToggle(300);
			$(this).closest('p').slideToggle(300);
			$('#dealer .equal-item').animate({
				'height': 'auto'
			}, 300, function()
			{
				equal_heights($('#dealer.equal-heights'), '.equal-item');
			});
		});
	}

	/**
	 * CROSS-BROWSER
	 */
	if(navigator.userAgent.match(/msie/i))
	{
		if(parseInt(rv) <= 8)
		{
			$('#news article .text p:last-child, #products article a.main p:last-child, #content section.intro p:last-child, #content section .text p:last-child').css({
				'margin-bottom': 0
			});
			$('form[name="frm-contact"] .column:nth-child(3n+3)').css({
				'margin-right': 0
			});
		}
	}
});
$(window).load(function() { position_elements(); });
$(window).resize(function() { position_elements(); });

/**
 * FUNCTIONS
 */

function position_elements()
{
	var scr_height = (window.innerHeight),
		scr_width  = (window.innerWidth);

	if(scr_width > 768) $('nav[role="navigation"]').removeAttr('style');

	if($('.equal-heights').length) $('.equal-heights').eqHeights({child:'.equal-item'});
}

function equal_heights(selector, item)
{
	selector.each(function()
	{
		var highest = 0;

		$(this).find(item).each(function()
		{
			if($(this).height() > highest) highest = $(this).height();
		});
		$(this).find(item).height(highest);
	});
}

/******************************
 * forms validate
 ******************************/
function setup_forms()
{
	if($('form').length)
	{
		jQuery.validator.setDefaults({
			onkeyup		: false,
			ignoreTitle	: true,
			rules		: {
				'fld-password'	: { minlength: 8 },
				's'				: { minlength: 3 }
			}
		});
//		$('form').validate({
//			submitHandler : function(form) { form.submit(); }
//		});

		$('form[name="frm-contact"]').validate({
			submitHandler : function(form) {
				var day = $('#doublecheck').attr('data-day');
				//console.log(day);
				$('#doublecheck').val(day);
				form.submit();
			}
		});
		$('form[name="frm-login"]').validate({
			submitHandler : function(form) { form.submit(); }
		});
		$('form[name="frm-password"]').validate({
			submitHandler	: function(form) { form.submit(); }
		});
		$('form[name="frm-register"]').validate({
			submitHandler	: function(form) { form.submit(); }
		});
		$('form[name="frm-newsletter"]').validate({
			errorPlacement	: function() { return false; },
			submitHandler	: function(form)
			{
				$(form).find('p.result').fadeOut('fast');

				$.ajax({ url: '/custom/ajax.php/',
					type	: 'POST',
					data	: {
						emailAdres : $(form).find('input[name="fld-email"]').val()
					},
					success	: function()
					{
						$(form).find('p.result').stop().fadeIn('fast');
					},
					error	: function(){ alert('Probleem, probeer opnieuw.'); }
				});
			}
		});
	}
}



$.fn.eqHeights = function(options) {

    var defaults = {  
        child: false 
    };  
    var options = $.extend(defaults, options); 

    var el = $(this);
    if (el.length > 0 && !el.data('eqHeights')) {
        $(window).bind('resize.eqHeights', function() {
            el.eqHeights();
        });
        el.data('eqHeights', true);
    }

    if( options.child && options.child.length > 0 ){
        var elmtns = $(options.child, this);
    } else {
        var elmtns = $(this).children();
    }

    var prevTop = 0;
    var max_height = 0;
    var elements = [];
    elmtns.height('auto').each(function() {

        var thisTop = this.offsetTop;

        if (prevTop > 0 && prevTop != thisTop) {
            $(elements).height(max_height);
            max_height = $(this).height();
            elements = [];
        }
        max_height = Math.max(max_height, $(this).height());

        prevTop = this.offsetTop;
        elements.push(this);
    });

    $(elements).height(max_height);
};

/*
CSS Browser Selector v0.4.0 (Nov 02, 2010) / http://rafael.adm.br/css_browser_selector
*/
function css_browser_selector(u){var ua=u.toLowerCase(),is=function(t){return ua.indexOf(t)>-1},g='gecko',w='webkit',s='safari',o='opera',m='mobile',h=document.documentElement,b=[(!(/opera|webtv/i.test(ua))&&/msie\s(\d)/.test(ua))?('ie ie'+RegExp.$1):is('firefox/2')?g+' ff2':is('firefox/3.5')?g+' ff3 ff3_5':is('firefox/3.6')?g+' ff3 ff3_6':is('firefox/3')?g+' ff3':is('gecko/')?g:is('opera')?o+(/version\/(\d+)/.test(ua)?' '+o+RegExp.$1:(/opera(\s|\/)(\d+)/.test(ua)?' '+o+RegExp.$2:'')):is('konqueror')?'konqueror':is('blackberry')?m+' blackberry':is('android')?m+' android':is('chrome')?w+' chrome':is('iron')?w+' iron':is('applewebkit/')?w+' '+s+(/version\/(\d+)/.test(ua)?' '+s+RegExp.$1:''):is('mozilla/')?g:'',is('j2me')?m+' j2me':is('iphone')?m+' iphone':is('ipod')?m+' ipod':is('ipad')?m+' ipad':is('mac')?'mac':is('darwin')?'mac':is('webtv')?'webtv':is('win')?'win'+(is('windows nt 6.0')?' vista':''):is('freebsd')?'freebsd':(is('x11')||is('linux'))?'linux':'','js']; c = b.join(' '); h.className += ' '+c; return c;};

/*
jQuery easing
*/
jQuery.easing.jswing=jQuery.easing.swing;jQuery.extend(jQuery.easing,{def:"easeOutQuad",swing:function(e,f,a,h,g){return jQuery.easing[jQuery.easing.def](e,f,a,h,g)},easeInQuad:function(e,f,a,h,g){return h*(f/=g)*f+a},easeOutQuad:function(e,f,a,h,g){return -h*(f/=g)*(f-2)+a},easeInOutQuad:function(e,f,a,h,g){if((f/=g/2)<1){return h/2*f*f+a}return -h/2*((--f)*(f-2)-1)+a},easeInCubic:function(e,f,a,h,g){return h*(f/=g)*f*f+a},easeOutCubic:function(e,f,a,h,g){return h*((f=f/g-1)*f*f+1)+a},easeInOutCubic:function(e,f,a,h,g){if((f/=g/2)<1){return h/2*f*f*f+a}return h/2*((f-=2)*f*f+2)+a},easeInQuart:function(e,f,a,h,g){return h*(f/=g)*f*f*f+a},easeOutQuart:function(e,f,a,h,g){return -h*((f=f/g-1)*f*f*f-1)+a},easeInOutQuart:function(e,f,a,h,g){if((f/=g/2)<1){return h/2*f*f*f*f+a}return -h/2*((f-=2)*f*f*f-2)+a},easeInQuint:function(e,f,a,h,g){return h*(f/=g)*f*f*f*f+a},easeOutQuint:function(e,f,a,h,g){return h*((f=f/g-1)*f*f*f*f+1)+a},easeInOutQuint:function(e,f,a,h,g){if((f/=g/2)<1){return h/2*f*f*f*f*f+a}return h/2*((f-=2)*f*f*f*f+2)+a},easeInSine:function(e,f,a,h,g){return -h*Math.cos(f/g*(Math.PI/2))+h+a},easeOutSine:function(e,f,a,h,g){return h*Math.sin(f/g*(Math.PI/2))+a},easeInOutSine:function(e,f,a,h,g){return -h/2*(Math.cos(Math.PI*f/g)-1)+a},easeInExpo:function(e,f,a,h,g){return(f==0)?a:h*Math.pow(2,10*(f/g-1))+a},easeOutExpo:function(e,f,a,h,g){return(f==g)?a+h:h*(-Math.pow(2,-10*f/g)+1)+a},easeInOutExpo:function(e,f,a,h,g){if(f==0){return a}if(f==g){return a+h}if((f/=g/2)<1){return h/2*Math.pow(2,10*(f-1))+a}return h/2*(-Math.pow(2,-10*--f)+2)+a},easeInCirc:function(e,f,a,h,g){return -h*(Math.sqrt(1-(f/=g)*f)-1)+a},easeOutCirc:function(e,f,a,h,g){return h*Math.sqrt(1-(f=f/g-1)*f)+a},easeInOutCirc:function(e,f,a,h,g){if((f/=g/2)<1){return -h/2*(Math.sqrt(1-f*f)-1)+a}return h/2*(Math.sqrt(1-(f-=2)*f)+1)+a},easeInElastic:function(f,h,e,l,k){var i=1.70158;var j=0;var g=l;if(h==0){return e}if((h/=k)==1){return e+l}if(!j){j=k*0.3}if(g<Math.abs(l)){g=l;var i=j/4}else{var i=j/(2*Math.PI)*Math.asin(l/g)}return -(g*Math.pow(2,10*(h-=1))*Math.sin((h*k-i)*(2*Math.PI)/j))+e},easeOutElastic:function(f,h,e,l,k){var i=1.70158;var j=0;var g=l;if(h==0){return e}if((h/=k)==1){return e+l}if(!j){j=k*0.3}if(g<Math.abs(l)){g=l;var i=j/4}else{var i=j/(2*Math.PI)*Math.asin(l/g)}return g*Math.pow(2,-10*h)*Math.sin((h*k-i)*(2*Math.PI)/j)+l+e},easeInOutElastic:function(f,h,e,l,k){var i=1.70158;var j=0;var g=l;if(h==0){return e}if((h/=k/2)==2){return e+l}if(!j){j=k*(0.3*1.5)}if(g<Math.abs(l)){g=l;var i=j/4}else{var i=j/(2*Math.PI)*Math.asin(l/g)}if(h<1){return -0.5*(g*Math.pow(2,10*(h-=1))*Math.sin((h*k-i)*(2*Math.PI)/j))+e}return g*Math.pow(2,-10*(h-=1))*Math.sin((h*k-i)*(2*Math.PI)/j)*0.5+l+e},easeInBack:function(e,f,a,i,h,g){if(g==undefined){g=1.70158}return i*(f/=h)*f*((g+1)*f-g)+a},easeOutBack:function(e,f,a,i,h,g){if(g==undefined){g=1.70158}return i*((f=f/h-1)*f*((g+1)*f+g)+1)+a},easeInOutBack:function(e,f,a,i,h,g){if(g==undefined){g=1.70158}if((f/=h/2)<1){return i/2*(f*f*(((g*=(1.525))+1)*f-g))+a}return i/2*((f-=2)*f*(((g*=(1.525))+1)*f+g)+2)+a},easeInBounce:function(e,f,a,h,g){return h-jQuery.easing.easeOutBounce(e,g-f,0,h,g)+a},easeOutBounce:function(e,f,a,h,g){if((f/=g)<(1/2.75)){return h*(7.5625*f*f)+a}else{if(f<(2/2.75)){return h*(7.5625*(f-=(1.5/2.75))*f+0.75)+a}else{if(f<(2.5/2.75)){return h*(7.5625*(f-=(2.25/2.75))*f+0.9375)+a}else{return h*(7.5625*(f-=(2.625/2.75))*f+0.984375)+a}}}},easeInOutBounce:function(e,f,a,h,g){if(f<g/2){return jQuery.easing.easeInBounce(e,f*2,0,h,g)*0.5+a}return jQuery.easing.easeOutBounce(e,f*2-g,0,h,g)*0.5+h*0.5+a}});